import { FileTypeName } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { DocumentsTableFeature } from 'modules/client/common/feature';

export const IdentityDocumentSection = () => {
  const { t } = useTranslation();

  return (
    <DocumentsTableFeature
      fileType={FileTypeName.IdentityDocument}
      name="identityDocument.files"
      title={t('client.legal.legalClientFirstHead.identityDocument.title')}
      titleVariant="subtitle"
    />
  );
};
